// @ts-nocheck
import {
    chain,
    SetPaymentDetailsState,
} from "@insite/client-framework/Store/Pages/OnePageCheckout/Handlers/SetPaymentDetailsState";
import { addToChainAfter, createChainHandler } from "@toolkit/Modules/client-framework/HandlerCreator";

/**
errorMessage: PO number 'INV001' has already been used for a previous order.
- Example1: INV001 → same value as in error (regex=true) → keep error
- Example2: INV0011 → different value (regex=false) → clear error.
**/
const poNumberExistsInMessage = (poNumber: string | undefined, errorMessage: string) => {
    if (!poNumber) {
        return false;
    }

    // Escape regex-special characters so the PO number is matched literally.
    const escaped = poNumber.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    // \b word boundaries ensure an exact match (e.g. "123" won't match inside "1234").
    return new RegExp(`\\b${escaped}\\b`).test(errorMessage);
};

export const ClearOnePageCheckoutPlaceOrderErrorMessages = createChainHandler(
    "ClearOnePageCheckoutPlaceOrderErrorMessages",
    chain,
    props => {
        const state = props.getState();
        const errorMessage = state?.pages?.onePageCheckout?.placeOrderErrorMessage;

        if (
            errorMessage &&
            props.parameter.paymentDetailsState === "complete" &&
            "poNumber" in props.parameter &&
            !poNumberExistsInMessage(props.parameter.poNumber as string, errorMessage)
        ) {
            props.dispatch({
                type: "Pages/OnePageCheckout/SetPlaceOrderErrorMessage",
                errorMessage: undefined,
            });
        }
    },
);

addToChainAfter(chain, SetPaymentDetailsState, ClearOnePageCheckoutPlaceOrderErrorMessages);
